"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var react_1 = __importDefault(require("react"));
var inertia_1 = require("@inertiajs/inertia");
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var roleLabels = {
    admin: 'Admin',
    approver: 'Approver',
    submitter: 'Submitter',
    viewer: 'Viewer',
};
function Users(_a) {
    var _b;
    var users = _a.users, roles = _a.roles;
    var route = (0, useRoute_1.default)();
    var buildRoleMap = function (list) {
        var map = {};
        list.forEach(function (user) {
            map[user.id] = user.role;
        });
        return map;
    };
    var buildActiveMap = function (list) {
        var map = {};
        list.forEach(function (user) {
            map[user.id] = user.is_active;
        });
        return map;
    };
    var _c = react_1.default.useState(function () {
        return buildRoleMap(users);
    }), rolesById = _c[0], setRolesById = _c[1];
    var _d = react_1.default.useState(function () {
        return buildActiveMap(users);
    }), activeById = _d[0], setActiveById = _d[1];
    var _e = react_1.default.useState(null), savingRoleId = _e[0], setSavingRoleId = _e[1];
    var _f = react_1.default.useState(null), savingStatusId = _f[0], setSavingStatusId = _f[1];
    var _g = react_1.default.useState(''), error = _g[0], setError = _g[1];
    var _h = react_1.default.useState(''), createError = _h[0], setCreateError = _h[1];
    var _j = react_1.default.useState(false), creating = _j[0], setCreating = _j[1];
    var _k = react_1.default.useState({
        name: '',
        email: '',
        role: (_b = roles[0]) !== null && _b !== void 0 ? _b : 'submitter',
        password: '',
        password_confirmation: '',
    }), form = _k[0], setForm = _k[1];
    react_1.default.useEffect(function () {
        setRolesById(buildRoleMap(users));
        setActiveById(buildActiveMap(users));
    }, [users]);
    var handleSave = function (userId) {
        setSavingRoleId(userId);
        setError('');
        inertia_1.Inertia.patch("/users/".concat(userId), { role: rolesById[userId] }, {
            preserveScroll: true,
            onError: function (errors) {
                var message = typeof (errors === null || errors === void 0 ? void 0 : errors.role) === 'string' ? errors.role : 'Update failed.';
                setError(message);
            },
            onFinish: function () {
                setSavingRoleId(null);
            },
        });
    };
    var handleToggleActive = function (userId) {
        var nextActive = !activeById[userId];
        setSavingStatusId(userId);
        setError('');
        inertia_1.Inertia.patch("/users/".concat(userId), { is_active: nextActive }, {
            preserveScroll: true,
            onSuccess: function () {
                setActiveById(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[userId] = nextActive, _a)));
                });
            },
            onError: function (errors) {
                var message = typeof (errors === null || errors === void 0 ? void 0 : errors.is_active) === 'string'
                    ? errors.is_active
                    : typeof (errors === null || errors === void 0 ? void 0 : errors.role) === 'string'
                        ? errors.role
                        : 'Update failed.';
                setError(message);
            },
            onFinish: function () {
                setSavingStatusId(null);
            },
        });
    };
    var handleCreate = function () {
        setCreateError('');
        setCreating(true);
        inertia_1.Inertia.post(route('users.store'), form, {
            preserveScroll: true,
            onSuccess: function () {
                var _a;
                setForm({
                    name: '',
                    email: '',
                    role: (_a = roles[0]) !== null && _a !== void 0 ? _a : 'submitter',
                    password: '',
                    password_confirmation: '',
                });
            },
            onError: function (errors) {
                var message = typeof (errors === null || errors === void 0 ? void 0 : errors.email) === 'string'
                    ? errors.email
                    : typeof (errors === null || errors === void 0 ? void 0 : errors.password) === 'string'
                        ? errors.password
                        : typeof (errors === null || errors === void 0 ? void 0 : errors.name) === 'string'
                            ? errors.name
                            : typeof (errors === null || errors === void 0 ? void 0 : errors.role) === 'string'
                                ? errors.role
                                : 'User creation failed.';
                setCreateError(message);
            },
            onFinish: function () {
                setCreating(false);
            },
        });
    };
    return (react_1.default.createElement(AppLayout_1.default, { title: "Users", renderHeader: function () { return (react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement("p", { className: "text-xs uppercase tracking-[0.3em] text-green-500" }, "Access Control"),
            react_1.default.createElement("h2", { className: "text-2xl font-semibold text-gray-900" }, "Users"),
            react_1.default.createElement("p", { className: "text-sm text-gray-500" }, "Manage staff access to submit and approve points"))); } },
        react_1.default.createElement("div", { className: "py-12" },
            react_1.default.createElement("div", { className: "mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" },
                react_1.default.createElement("div", { className: "rounded-2xl border border-slate-100 bg-white p-6 shadow-sm" },
                    react_1.default.createElement("div", { className: "mb-6" },
                        react_1.default.createElement("p", { className: "text-xs uppercase tracking-wide text-slate-400" }, "Add user"),
                        react_1.default.createElement("h3", { className: "mt-1 text-sm font-semibold text-slate-900" }, "Create a new account")),
                    createError && (react_1.default.createElement("div", { className: "mb-4 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700" }, createError)),
                    react_1.default.createElement("div", { className: "grid gap-4 md:grid-cols-2" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("label", { className: "text-xs uppercase tracking-wide text-slate-400" }, "Name"),
                            react_1.default.createElement("input", { value: form.name, onChange: function (event) { return setForm(function (current) { return (__assign(__assign({}, current), { name: event.target.value })); }); }, className: "mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" })),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("label", { className: "text-xs uppercase tracking-wide text-slate-400" }, "Email"),
                            react_1.default.createElement("input", { type: "email", value: form.email, onChange: function (event) { return setForm(function (current) { return (__assign(__assign({}, current), { email: event.target.value })); }); }, className: "mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" })),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("label", { className: "text-xs uppercase tracking-wide text-slate-400" }, "Role"),
                            react_1.default.createElement("select", { value: form.role, onChange: function (event) { return setForm(function (current) { return (__assign(__assign({}, current), { role: event.target.value })); }); }, className: "mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm" }, roles.map(function (role) {
                                var _a;
                                return (react_1.default.createElement("option", { key: role, value: role }, (_a = roleLabels[role]) !== null && _a !== void 0 ? _a : role));
                            }))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("label", { className: "text-xs uppercase tracking-wide text-slate-400" }, "Password"),
                            react_1.default.createElement("input", { type: "password", value: form.password, onChange: function (event) { return setForm(function (current) { return (__assign(__assign({}, current), { password: event.target.value })); }); }, className: "mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" })),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("label", { className: "text-xs uppercase tracking-wide text-slate-400" }, "Confirm password"),
                            react_1.default.createElement("input", { type: "password", value: form.password_confirmation, onChange: function (event) {
                                    return setForm(function (current) { return (__assign(__assign({}, current), { password_confirmation: event.target.value })); });
                                }, className: "mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" }))),
                    react_1.default.createElement("div", { className: "mt-4 flex justify-end" },
                        react_1.default.createElement("button", { type: "button", onClick: handleCreate, disabled: creating ||
                                !form.name ||
                                !form.email ||
                                !form.password ||
                                !form.password_confirmation, className: "rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white disabled:opacity-60" }, creating ? 'Creating...' : 'Add user'))),
                react_1.default.createElement("div", { className: "mt-6 rounded-2xl border border-slate-100 bg-white p-6 shadow-sm" },
                    error && (react_1.default.createElement("div", { className: "mb-4 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700" }, error)),
                    users.length === 0 ? (react_1.default.createElement("p", { className: "text-sm text-slate-500" }, "No users found.")) : (react_1.default.createElement("div", { className: "overflow-x-auto" },
                        react_1.default.createElement("table", { className: "min-w-full divide-y divide-slate-100 text-sm" },
                            react_1.default.createElement("thead", { className: "text-left text-xs uppercase tracking-wide text-slate-400" },
                                react_1.default.createElement("tr", null,
                                    react_1.default.createElement("th", { className: "px-3 py-2" }, "Name"),
                                    react_1.default.createElement("th", { className: "px-3 py-2" }, "Email"),
                                    react_1.default.createElement("th", { className: "px-3 py-2" }, "Status"),
                                    react_1.default.createElement("th", { className: "px-3 py-2" }, "Role"),
                                    react_1.default.createElement("th", { className: "px-3 py-2" }, "Actions"))),
                            react_1.default.createElement("tbody", { className: "divide-y divide-slate-100" }, users.map(function (user) { return (react_1.default.createElement("tr", { key: user.id },
                                react_1.default.createElement("td", { className: "px-3 py-3 font-medium text-slate-900" }, user.name),
                                react_1.default.createElement("td", { className: "px-3 py-3 text-slate-500" }, user.email),
                                react_1.default.createElement("td", { className: "px-3 py-3" },
                                    react_1.default.createElement("span", { className: "rounded-full px-3 py-1 text-xs font-semibold ".concat(activeById[user.id]
                                            ? 'bg-emerald-50 text-emerald-700'
                                            : 'bg-rose-50 text-rose-700') }, activeById[user.id] ? 'Active' : 'Disabled')),
                                react_1.default.createElement("td", { className: "px-3 py-3" },
                                    react_1.default.createElement("select", { value: rolesById[user.id], onChange: function (event) {
                                            var value = event.target.value;
                                            setRolesById(function (prev) {
                                                var _a;
                                                return (__assign(__assign({}, prev), (_a = {}, _a[user.id] = value, _a)));
                                            });
                                        }, className: "rounded-full border border-slate-200 bg-white px-3 py-1 text-xs text-slate-600" }, roles.map(function (role) {
                                        var _a;
                                        return (react_1.default.createElement("option", { key: role, value: role }, (_a = roleLabels[role]) !== null && _a !== void 0 ? _a : role));
                                    }))),
                                react_1.default.createElement("td", { className: "px-3 py-3" },
                                    react_1.default.createElement("div", { className: "flex flex-wrap items-center gap-2" },
                                        react_1.default.createElement("button", { type: "button", onClick: function () { return handleSave(user.id); }, disabled: savingRoleId === user.id || savingStatusId === user.id, className: "rounded-full bg-green-600 px-4 py-1.5 text-xs font-semibold text-white transition hover:bg-green-500 disabled:opacity-60" }, savingRoleId === user.id ? 'Saving...' : 'Save'),
                                        react_1.default.createElement("button", { type: "button", onClick: function () { return handleToggleActive(user.id); }, disabled: savingStatusId === user.id, className: "rounded-full px-4 py-1.5 text-xs font-semibold transition disabled:opacity-60 ".concat(activeById[user.id]
                                                ? 'border border-rose-300 text-rose-600 hover:bg-rose-50'
                                                : 'border border-emerald-300 text-emerald-600 hover:bg-emerald-50') }, savingStatusId === user.id
                                            ? 'Updating...'
                                            : activeById[user.id]
                                                ? 'Disable'
                                                : 'Enable'))))); }))))))))));
}
exports.default = Users;
